import AddEditTransferMultiSetFilter from '@/common/addEditTransferMultiSetFilter';
import { FilterMode } from '@/queue/types';
import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';

export default function CustomDropDown({
  children,
  className,
  handleClickOutside,
  filterMode
}: {
  children: React.ReactNode;
  handleClickOutside: (event: any) => void;
  filterMode?: FilterMode;
  className?: string;
}) {
  useEffect(() => {
    const onDocumentClick = (event: MouseEvent) => {
      const target = event.target as Element | null;
      // Don't close when clicking inside react-select menu (it's portaled to body)
      if (target?.closest?.('.saved-filter-select__menu')) {
        return;
      }
      // Clear All lives inside the panel but must not dismiss the filter dropdown
      if (target?.closest?.('.clear-all-btn')) {
        return;
      }
      // Clicks inside the filter column (saved filters, Edit/Delete, Transfer filters).
      // Chakra buttons/SVG targets sometimes fail filterButtonRef.contains() in handleClickOutside.
      if (target?.closest?.('.custom-dropdown-component')) {
        return;
      }
      if (target?.closest?.('.transfer-multi-set-filter-wrapper-container')) {
        return;
      }
      handleClickOutside(event);
    };
    document.addEventListener('click', onDocumentClick);
    return () => {
      document.removeEventListener('click', onDocumentClick);
    };
  }, [handleClickOutside]);
  return (
    <>
      <Box className={`custom-dropdown-component filter-column ${className}`}>
        <>
        {filterMode && filterMode === FilterMode.TRANSFER_FILTER && (
          <AddEditTransferMultiSetFilter />
        )}
        {children}
        </>
      </Box>
    </>
  );
}
